/**
 * Заглушка на время подгрузки чанка страницы.
 *
 * Страницы грузятся лениво, и между кликом и отрисовкой есть короткий
 * промежуток, когда показывать нечего. Пустой экран в этот момент читается
 * как поломка, поэтому здесь спокойный спиннер в стиле остального интерфейса.
 */
export default function PageLoader() {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "60vh",
                width: "100%",
            }}
        >
            <div
                aria-label="Загрузка"
                style={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    border: "3px solid var(--card-border, #e5e7eb)",
                    borderTopColor: "var(--accent, #f97316)",
                    animation: "page-loader-spin 0.7s linear infinite",
                }}
            />
            <style>{`
                @keyframes page-loader-spin { to { transform: rotate(360deg); } }
            `}</style>
        </div>
    );
}
